module.exports = __webpack_public_path__ + "static/img/稽核智能体.7e1b3c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/operationDecision/稽核智能体.jpg
// module id = eyen
// module chunks = 0